/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse20012Details1Facilities from './InlineResponse20012Details1Facilities';
import InlineResponse20012Details1Rooms from './InlineResponse20012Details1Rooms';
import InlineResponse20012RentStatusWeight from './InlineResponse20012RentStatusWeight';

/**
 * The InlineResponse20012Details1 model module.
 * @module model/InlineResponse20012Details1
 * @version 1.0
 */
class InlineResponse20012Details1 {
    /**
     * Constructs a new <code>InlineResponse20012Details1</code>.
     * @alias module:model/InlineResponse20012Details1
     */
    constructor() {

        InlineResponse20012Details1.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) {}

    /**
     * Constructs a <code>InlineResponse20012Details1</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012Details1} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012Details1} The populated <code>InlineResponse20012Details1</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012Details1();

            if (data.hasOwnProperty('energyScore')) {
                obj['energyScore'] = ApiClient.convertToType(data['energyScore'], 'String');
            }
            if (data.hasOwnProperty('rooms')) {
                obj['rooms'] = ApiClient.convertToType(data['rooms'], [InlineResponse20012Details1Rooms]);
            }
            if (data.hasOwnProperty('roomNumber')) {
                obj['roomNumber'] = ApiClient.convertToType(data['roomNumber'], 'String');
            }
            if (data.hasOwnProperty('heatingScore')) {
                obj['heatingScore'] = ApiClient.convertToType(data['heatingScore'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('ctaUris')) {
                obj['ctaUris'] = ApiClient.convertToType(data['ctaUris'], Object);
            }
            if (data.hasOwnProperty('electricityMeter')) {
                obj['electricityMeter'] = ApiClient.convertToType(data['electricityMeter'], 'String');
            }
            if (data.hasOwnProperty('electricityMeterId')) {
                obj['electricityMeterId'] = ApiClient.convertToType(data['electricityMeterId'], 'String');
            }
            if (data.hasOwnProperty('smokingAllowed')) {
                obj['smokingAllowed'] = ApiClient.convertToType(data['smokingAllowed'], 'Boolean');
            }
            if (data.hasOwnProperty('furnished')) {
                obj['furnished'] = ApiClient.convertToType(data['furnished'], 'String');
            }
            if (data.hasOwnProperty('alias')) {
                obj['alias'] = ApiClient.convertToType(data['alias'], 'String');
            }
            if (data.hasOwnProperty('professional_landlord')) {
                obj['professional_landlord'] = ApiClient.convertToType(data['professional_landlord'], 'Boolean');
            }
            if (data.hasOwnProperty('houseRules')) {
                obj['houseRules'] = ApiClient.convertToType(data['houseRules'], 'String');
            }
            if (data.hasOwnProperty('floor')) {
                obj['floor'] = ApiClient.convertToType(data['floor'], 'Number');
            }
            if (data.hasOwnProperty('areaSize')) {
                obj['areaSize'] = ApiClient.convertToType(data['areaSize'], 'String');
            }
            if (data.hasOwnProperty('roomCount')) {
                obj['roomCount'] = ApiClient.convertToType(data['roomCount'], 'String');
            }
            if (data.hasOwnProperty('animalsAllowed')) {
                obj['animalsAllowed'] = ApiClient.convertToType(data['animalsAllowed'], 'Boolean');
            }
            if (data.hasOwnProperty('weight')) {
                obj['weight'] = InlineResponse20012RentStatusWeight.constructFromObject(data['weight']);
            }
            if (data.hasOwnProperty('profilePictureUri')) {
                obj['profilePictureUri'] = ApiClient.convertToType(data['profilePictureUri'], 'String');
            }
            if (data.hasOwnProperty('uri')) {
                obj['uri'] = ApiClient.convertToType(data['uri'], 'String');
            }
            if (data.hasOwnProperty('buildingId')) {
                obj['buildingId'] = ApiClient.convertToType(data['buildingId'], 'String');
            }
            if (data.hasOwnProperty('specialRemarks')) {
                obj['specialRemarks'] = ApiClient.convertToType(data['specialRemarks'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
            if (data.hasOwnProperty('facilities')) {
                obj['facilities'] = ApiClient.convertToType(data['facilities'], [InlineResponse20012Details1Facilities]);
            }
            if (data.hasOwnProperty('apartmentNumber')) {
                obj['apartmentNumber'] = ApiClient.convertToType(data['apartmentNumber'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/InlineResponse20012Details1.EnergyScoreEnum} energyScore
 */
InlineResponse20012Details1.prototype['energyScore'] = undefined;

/**
 * @member {Array.<module:model/InlineResponse20012Details1Rooms>} rooms
 */
InlineResponse20012Details1.prototype['rooms'] = undefined;

/**
 * @member {String} roomNumber
 */
InlineResponse20012Details1.prototype['roomNumber'] = undefined;

/**
 * @member {module:model/InlineResponse20012Details1.HeatingScoreEnum} heatingScore
 */
InlineResponse20012Details1.prototype['heatingScore'] = undefined;

/**
 * @member {module:model/InlineResponse20012Details1.TypeEnum} type
 */
InlineResponse20012Details1.prototype['type'] = undefined;

/**
 * @member {Object} ctaUris
 */
InlineResponse20012Details1.prototype['ctaUris'] = undefined;

/**
 * @member {String} electricityMeter
 */
InlineResponse20012Details1.prototype['electricityMeter'] = undefined;

/**
 * @member {String} electricityMeterId
 */
InlineResponse20012Details1.prototype['electricityMeterId'] = undefined;

/**
 * @member {Boolean} smokingAllowed
 */
InlineResponse20012Details1.prototype['smokingAllowed'] = undefined;

/**
 * @member {module:model/InlineResponse20012Details1.FurnishedEnum} furnished
 */
InlineResponse20012Details1.prototype['furnished'] = undefined;

/**
 * @member {String} alias
 */
InlineResponse20012Details1.prototype['alias'] = undefined;

/**
 * @member {Boolean} professional_landlord
 */
InlineResponse20012Details1.prototype['professional_landlord'] = undefined;

/**
 * @member {String} houseRules
 */
InlineResponse20012Details1.prototype['houseRules'] = undefined;

/**
 * @member {Number} floor
 */
InlineResponse20012Details1.prototype['floor'] = undefined;

/**
 * @member {String} areaSize
 */
InlineResponse20012Details1.prototype['areaSize'] = undefined;

/**
 * @member {String} roomCount
 */
InlineResponse20012Details1.prototype['roomCount'] = undefined;

/**
 * @member {Boolean} animalsAllowed
 */
InlineResponse20012Details1.prototype['animalsAllowed'] = undefined;

/**
 * @member {module:model/InlineResponse20012RentStatusWeight} weight
 */
InlineResponse20012Details1.prototype['weight'] = undefined;

/**
 * @member {String} profilePictureUri
 */
InlineResponse20012Details1.prototype['profilePictureUri'] = undefined;

/**
 * @member {String} uri
 */
InlineResponse20012Details1.prototype['uri'] = undefined;

/**
 * @member {String} buildingId
 */
InlineResponse20012Details1.prototype['buildingId'] = undefined;

/**
 * @member {String} specialRemarks
 */
InlineResponse20012Details1.prototype['specialRemarks'] = undefined;

/**
 * @member {String} name
 */
InlineResponse20012Details1.prototype['name'] = undefined;

/**
 * @member {String} comment
 */
InlineResponse20012Details1.prototype['comment'] = undefined;

/**
 * @member {Array.<module:model/InlineResponse20012Details1Facilities>} facilities
 */
InlineResponse20012Details1.prototype['facilities'] = undefined;

/**
 * @member {String} apartmentNumber
 */
InlineResponse20012Details1.prototype['apartmentNumber'] = undefined;





/**
 * Allowed values for the <code>energyScore</code> property.
 * @enum {String}
 * @readonly
 */
InlineResponse20012Details1['EnergyScoreEnum'] = {

    /**
     * value: "Ikke valgt"
     * @const
     */
    "Ikke valgt": "Ikke valgt",

    /**
     * value: "A"
     * @const
     */
    "A": "A",

    /**
     * value: "B"
     * @const
     */
    "B": "B",

    /**
     * value: "C"
     * @const
     */
    "C": "C",

    /**
     * value: "D"
     * @const
     */
    "D": "D",

    /**
     * value: "E"
     * @const
     */
    "E": "E",

    /**
     * value: "F"
     * @const
     */
    "F": "F"
};


/**
 * Allowed values for the <code>heatingScore</code> property.
 * @enum {String}
 * @readonly
 */
InlineResponse20012Details1['HeatingScoreEnum'] = {

    /**
     * value: "Ikke valgt"
     * @const
     */
    "Ikke valgt": "Ikke valgt",

    /**
     * value: "Mørkegrønn"
     * @const
     */
    "Mørkegrønn": "Mørkegrønn",

    /**
     * value: "Lysegrønn"
     * @const
     */
    "Lysegrønn": "Lysegrønn",

    /**
     * value: "Gul"
     * @const
     */
    "Gul": "Gul",

    /**
     * value: "Oransje"
     * @const
     */
    "Oransje": "Oransje",

    /**
     * value: "Rød"
     * @const
     */
    "Rød": "Rød"
};


/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
InlineResponse20012Details1['TypeEnum'] = {

    /**
     * value: "apartment"
     * @const
     */
    "apartment": "apartment",

    /**
     * value: "house"
     * @const
     */
    "house": "house",

    /**
     * value: "co-op"
     * @const
     */
    "co-op": "co-op",

    /**
     * value: "basement flat"
     * @const
     */
    "basement flat": "basement flat",

    /**
     * value: "dorm"
     * @const
     */
    "dorm": "dorm",

    /**
     * value: "semi-detached"
     * @const
     */
    "semi-detached": "semi-detached",

    /**
     * value: "chained-house"
     * @const
     */
    "chained-house": "chained-house",

    /**
     * value: "commercial"
     * @const
     */
    "commercial": "commercial",

    /**
     * value: "garage-parking"
     * @const
     */
    "garage-parking": "garage-parking",

    /**
     * value: "other"
     * @const
     */
    "other": "other",

    /**
     * value: "unknown"
     * @const
     */
    "unknown": "unknown"
};


/**
 * Allowed values for the <code>furnished</code> property.
 * @enum {String}
 * @readonly
 */
InlineResponse20012Details1['FurnishedEnum'] = {

    /**
     * value: "Ikke valgt"
     * @const
     */
    "Ikke valgt": "Ikke valgt",

    /**
     * value: "Umøblert"
     * @const
     */
    "Umøblert": "Umøblert",

    /**
     * value: "Delvis Møblert"
     * @const
     */
    "Delvis Møblert": "Delvis Møblert",

    /**
     * value: "Møblert"
     * @const
     */
    "Møblert": "Møblert"
};



export default InlineResponse20012Details1;